const titleize = (str: string) =>
  str
    .split(' ')
    .map((substr) => substr.replace(/^([a-z])/, (match) => match.toUpperCase()))
    .join(' ');
export default titleize;
